import React from 'react'
import SettingApiForm from '../components/setting/settingIndexForm'

const SettingIndex = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingIndex